$("input[name='consent-1']").click(function() {
  if(!$(this).is(':checked')) {
    $("input[name='consent-2']").prop('checked', false);
    $("input[name='consent-3']").prop('checked', false);
    $("input[name='consent-4']").prop('checked', false);
    $("input[name='consent-5']").prop('checked', false);
  }
  else {
    $("input[name='consent-2']").prop('checked', true);
    $("input[name='consent-3']").prop('checked', true);
    $("input[name='consent-4']").prop('checked', true);
    $("input[name='consent-5']").prop('checked', true);
  }

});